var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"footer"},[_c('h2',{staticClass:"lunacali-logo",on:{"click":_vm.goToAbout}},[_vm._v("\n        l\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }